import React from "react";
import PropTypes from "prop-types";
import { cn } from "../utils/classNames";

// Single source of truth for the header wordmark, shared by NewHeader and
// SubpageHeader so the brand typography can't drift between pages.
// flex-none + whitespace-nowrap keep "PremiereLens" on one line; the
// header action cluster yields instead.
const BrandMark = ({ href = "", className = "", showWordmarkOnPhones = false }) => {
    const wrapperClasses = cn("flex flex-none items-center gap-2 sm:gap-3", className);
    const content = (
        <>
            <img
                src="/brand/premierelens-mark-v2.png"
                width="48"
                height="48"
                alt=""
                aria-hidden="true"
                className="brand-mark__symbol h-10 w-10 sm:h-12 sm:w-12"
            />
            <span className={cn("text-foreground text-h3 lg:text-h2 font-semibold tracking-tight whitespace-nowrap shadow-text-header", !showWordmarkOnPhones && "hidden sm:block")}>
                PremiereLens
            </span>
        </>
    );

    if (href) {
        return (
            <a href={href} className={cn(wrapperClasses, "no-underline")} aria-label="PremiereLens">
                {content}
            </a>
        );
    }

    return (
        <div className={wrapperClasses} aria-label="PremiereLens">
            {content}
        </div>
    );
};

BrandMark.propTypes = {
    href: PropTypes.string,
    className: PropTypes.string,
    showWordmarkOnPhones: PropTypes.bool,
};

export default BrandMark;
